<template>
	<v-main>
        <v-container>
			<v-data-table
				v-model="selected"
				:headers="headers"
				:items="items"
				item-key="id"
				show-select
				:loading="loading"
				:search="search"
				loading-text="Завантаження даних... зачекайте, будь ласка." 
				class_="mt-16"
				:items-per-page="-1"
				hide-default-footer
			>
				<template v-slot:top>
					<v-toolbar flat>
						<v-app-bar-nav-icon>
							<v-icon>{{ icon }}</v-icon>
						</v-app-bar-nav-icon>
						<v-toolbar-title>{{ $vuetify.lang.t(`$vuetify.${title}`) | capitalize }}</v-toolbar-title>
						<v-spacer></v-spacer>

						<v-spacer></v-spacer>
						<v-text-field
							v-model="search"
							append-icon="mdi-magnify"
							label="Пошук"
							single-line
							hide-details
							outlined
							rounded
							dense
						></v-text-field>
						<!-- Оновити -->
						<v-btn icon @click="onRefresh">
							<v-icon>mdi-refresh</v-icon>
						</v-btn>

						<!-- Пошук -->
						<!-- <v-btn icon @click="OnSearch">
							<v-icon>mdi-magnify</v-icon>
						</v-btn> -->

						<!-- Створити -->
						<!-- <z-detail
							activator-type="button"
							activator-outlined
							:activator-title="$vuetify.lang.t('$vuetify.create')"
							activator-tooltip-disabled
						></z-detail> -->

						<!-- <z-detail
							tooltip="create"
						>
							<template v-slot:activator="props">
								<v-btn icon fab v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">
									<v-icon>mdi-plus</v-icon>
								</v-btn>
							</template>
						</z-detail> -->
					</v-toolbar>
				</template>

				
				<template v-slot:[`item.active`]="{ item }">
					<v-tooltip bottom v-if="item.active">
						<template v-slot:activator="{ on, attrs }">
							<v-icon v-bind="attrs" v-on="on" color="success">mdi-circle</v-icon>
						</template>
						<span>{{ item.dateactive | formatDateTime }}</span>
					</v-tooltip>
					
				</template>
				<template v-slot:[`item.disabled`]="{ item }">
					<v-icon v-if="item.disabled" color="error">mdi-cancel</v-icon>
				</template>

				<template v-slot:[`item.actions`]="{ item }">
					<v-toolbar elevation="0" dense color="transparent">
						<z-detail v-if="permitionUpdate"
							:selected="item"
							@update="edit(item, $event)"
						></z-detail>

						<z-statistic :selected="item" ></z-statistic>

						<v-menu offset-y ref="menu" v-if="permitionLock">
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon v-bind="attrs" v-on="on">
									<v-icon>mdi-dots-vertical</v-icon>
								</v-btn>
							</template>
							<v-list v-if="permitionLock">
								<v-list-item v-if="item.disabled" @click="onUnlock(item)">
									<v-list-item-icon>
										<v-icon>mdi-account-check</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>Розблокувати</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-list-item v-else @click="onLock(item)">
									<v-list-item-icon>
										<v-icon>mdi-account-cancel</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>Заблокувати</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</v-list>
						</v-menu>
					</v-toolbar>
				</template>
			</v-data-table>

			
		</v-container>

		<z-detail v-if="permitionCreate"
			tooltip="create"
		>
			<template v-slot:activator="props">
				<v-fab-transition>
					<v-btn
						v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}"
						color="primary"
						dark
						fixed
						bottom
						right
						fab
						class="mb-8 mr-8"
						@create="add"
					>
						<v-icon>mdi-plus</v-icon>
					</v-btn>
				</v-fab-transition>
			</template>
		</z-detail>

		<!-- <v-footer app padless>
			<v-card flat tile width="100%" class="text-center">
				<v-card-text>
					<v-pagination
						v-model="page"
						:length="pageCount"
						:total-visible="7"
						
					></v-pagination>
				</v-card-text>
			</v-card>
		</v-footer> -->

		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
    </v-main>
</template>

<script>
import axios from 'axios'
import mixin from './mixin/main'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import downloadExcel from "vue-json-excel"
import zConfirmDelete from '@/views/components/confirm-delete'
//import zDetail from '@/views/details/Users'
import zDetail from '@/views/OrganizationDetail'
import zStatistic from '@/views/OrganizationStatisticDetail'


export default {
	name: 'Organizations',
	mixins: [mixin],
	components: {
		downloadExcel,
		zConfirmDelete,
		zDetail,
		zStatistic,
	},
	data: () => ({
		title: 'organizations',
		icon: 'mdi-domain',
		search: '',
		headers: [
			//{ text: 'ID', value: 'id', align: ' d-none' },
			{ text: 'ID', value: 'id', sortable: true},
			{ text: 'Назва', value: 'name', sortable: true},
			{ text: 'Тип', value: 'type.name', sortable: true},
			{ text: 'ЄДРПОУ', value: 'taxID', sortable: true},
			{ text: 'Блокування', value: 'disabled', sortable: true},
			{ text: 'Кількість запитів', value: 'cnt', sortable: true},
			{ text: 'Дії', value: 'actions', sortable: false },
		],

		page: 1,
		pageCount: 2,
		itemsPerPage: 15,

		showMenu: false,
	}),
	
	computed: {
		...mapGetters(['roles']),
		...mapGetters('Organization', [ 'endpoint', 'items' ]),

		permitionCreate() {
			return this.roles.includes('ADMIN')
		},

		permitionUpdate() {
			return this.roles.includes('ADMIN')
		},

		permitionDelete() {
			return this.roles.includes('ADMIN')
		},

		permitionLock() {
			//return this.roles.some(element => ['ADMIN', 'ORG_ADMIN'].includes(element))
			return this.roles.includes('ADMIN')
		},
	},

	methods: {
		...mapMutations('Organization', { 'setItems': 'items' }),

		onRefresh() {
			this.loading = true
			var that = this
			//axios.get('/organization/statistic').then(response => {
			axios.get(`/${this.endpoint}`).then(response => {
				//console.log(this.$options.name, 'load','response.data', response.data)
				that.setItems(response.data)
			}, error => {
				console.log(error)
				that.showMessage(error)
			}).finally(() => (this.loading = false));
		},

		onLock(item) {
			if(item) {
				this.loading = true
				var that = this
				axios.put(`/${this.endpoint}/${item.id}/lock`).then(response => {
					//console.log(this.$options.name, 'onLock','response.data', response.data)
					that.edit(item, response.data)
				}, error => {
					console.log(error)
					that.showMessage(error)
				}).finally(() => (this.loading = false));
			}
		},

		onUnlock(item) {
			if(item) {
				this.loading = true
				var that = this
				axios.put(`/${this.endpoint}/${item.id}/unlock`).then(response => {
					//console.log(this.$options.name, 'onLock','response.data', response.data)
					that.edit(item, response.data)
				}, error => {
					console.log(error)
					that.showMessage(error)
				}).finally(() => (this.loading = false));
			}
		},
	},
}
</script>